<template>
  <div
    v-if="samples.length"
    class="mx-5 px-2 py-2 my-6 rounded-2xl"
    :class="{
      'bg-[#333333]': activeMenu == 'lasted'
    }"
  >
    <div v-if="activeMenu != 'sample'" class="flex items-center mb-4 px-1">
      <div class="flex-1 text-[18px] font-medium">表盘样例</div>
      <Icon
        class="cursor-pointer"
        :icon="'delete2.svg'"
        :width="12"
        :height="12"
        fill="none"
        @click="handleHideSamples"
      />
    </div>
    <watch-face-list
      menu-type="sample"
      input-search-value=""
      :watch-faces="samples.filter((item) => canUse(item.deviceType ?? ''))"
      :categorize="false"
      :compact-uncategorized="true"
      :vertical-center="true"
      :preview-imgs="previewImgs"
    />
  </div>
</template>

<script setup lang="ts">
import { PropType, computed, onActivated, onMounted, ref, watch } from 'vue';
import {
  HistoryWatchfaceItem,
  useEmitterListener,
  useHomePreviewImgs,
  useWatchfaceDevices
} from '@/hooks';
import WatchFaceList from '../watchface-list/index.vue';
import { SampleService } from '@/services/sample.service';
import { EventType } from '@/utils/emitter.utils';
import { debounce } from 'lodash-es';
import { useRoute } from 'vue-router';

defineProps({
  activeMenu: {
    type: String as PropType<'collect' | 'lasted' | 'sample'>,
    default: ''
  }
});

const emits = defineEmits<{
  (event: 'hide'): void;
}>();

const { canUse } = useWatchfaceDevices();

// 表盘样例
const { previewImgs, generatePreviews } = useHomePreviewImgs();

const route = useRoute();

const samples = ref<HistoryWatchfaceItem[]>([]);
const _initSamples = async () => {
  if (route.name != 'home') return;

  // console.log('_initSamples');
  const service = new SampleService();
  const list = await service.getSamples();
  // 依次下载所有样例
  for (const item of list ?? []) {
    const { zip, name, size, deviceType } = item;
    service.downloadSampleZip(zip).then((r) => {
      if (r && !samples.value.find((item) => item.path == r)) {
        samples.value.push({
          title: name,
          size,
          deviceType,
          path: r,
          isSample: true
        });
      }
    });
  }
};

// 预览图
const previewPathItems = computed(() => {
  return samples.value.map((item) => {
    return {
      path: item.path,
      deviceType: item.deviceType
    };
  });
});
watch(
  previewPathItems,
  debounce(() => {
    if (route.name != 'home') return;
    generatePreviews(previewPathItems.value);
  }, 10)
);

const initSamples = debounce(_initSamples, 50);

onMounted(initSamples);
onActivated(initSamples);
useEmitterListener(EventType['window:foucs'], initSamples);

const handleHideSamples = () => {
  emits('hide');
};
</script>

<style scoped lang="less">
.search {
  :deep(.ant-input) {
    font-size: 16px;
    line-height: 20px !important;
    font-weight: 400;
    height: 20px;
  }
  .ant-input-affix-wrapper:before {
    display: none;
  }
}
</style>
